// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__kJC14","item":"Navigation_item__k1Fem","active":"Navigation_active__81+KC","btn":"Navigation_btn__4pxyP"};